// Where an admin opens a shipment at its carrier and an invoice at its payment vendor
// (XCUT-R24…R28, R32, R33); the telehealth Case is in telehealthLinks.

const carrierTrackingPages: Record<string, string> = {
  usps: "https://tools.usps.com/go/TrackConfirmAction?tLabels=",
  ups: "https://www.ups.com/track?tracknum=",
  fedex: "https://www.fedex.com/fedextrack/?trknbr=",
};

// An invoice ID names the vendor that holds it: Stripe invoices begin in_, and WithFlex stores
// its checkout session ID, which begins fcs_ (XCUT-R26, R27).
const invoicePages: [prefix: string, page: string][] = [
  ["in_", "https://dashboard.stripe.com/invoices/"],
  ["fcs_", "https://dashboard.withflex.com/checkout-sessions/"],
];

// The carrier's tracking page for one tracking number, or null for a carrier it has none of
// (XCUT-R24, R25).
export const carrierTrackingUrl = (
  carrier: string | null | undefined,
  trackingNumber: string
): string | null => {
  const page = carrier ? carrierTrackingPages[carrier] : undefined;
  if (!page) return null;

  return `${page}${encodeURIComponent(trackingNumber)}`;
};

// The vendor page of an invoice, or null for no invoice or an ID that names no vendor
// (XCUT-R26, R27, R32).
export const invoiceUrl = (invoiceId: string | null | undefined): string | null => {
  if (!invoiceId) return null;

  const match = invoicePages.find(([prefix]) => invoiceId.startsWith(prefix));
  if (!match) return null;

  return `${match[1]}${invoiceId}`;
};

// A Case's invoice opens where its ID says. The Case's payment provider does not decide it: a
// WithFlex Case can hold a Stripe invoice (XCUT-E31).
export const caseInvoiceUrl = ({
  invoiceId,
}: {
  invoiceId?: string | null;
  paymentProvider?: string | null;
}): string | null => invoiceUrl(invoiceId);

// An Order's invoice opens once its invoice has answered (XCUT-R28), where its ID says.
export const orderInvoiceUrl = (
  invoiceId: string,
  provider: string | null | undefined
): string | null => (provider ? invoiceUrl(invoiceId) : null);
